import type { Team } from "@repo/types";
import { Button } from "@repo/ui/components/Base/Button";
import { ConfirmDialog } from "@repo/ui/components/Base/ConfirmDialog";
import { EditIcon, TrashIcon } from "lucide-react";
import { useState } from "react";

export interface LaserficheMultiConnectionRowProps {
  label?: React.ReactNode;
  tenantId: string;
  team?: Team;
  isConnected?: boolean;
  onConnect?: (tenantId: string, teamId?: string) => void;
  onEdit?: (tenantId: string, teamId?: string) => void;
  onDisconnect?: (tenantId: string, teamId?: string) => void | Promise<void>;
}

export const LaserficheMultiConnectionRow = ({
  label,
  tenantId,
  team,
  isConnected,
  onConnect,
  onEdit,
  onDisconnect,
}: LaserficheMultiConnectionRowProps) => {
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  return (
    <div className="flex flex-row items-center gap-8">
      <ConfirmDialog
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        confirmLabel="Delete"
        message={`Are you sure you want to delete the ${
          team
            ? `Laserfiche connection for team, ${team.name}?`
            : "default Laserfiche connection?"
        } This action cannot be undone.`}
        onSubmit={async () => {
          await onDisconnect?.(tenantId, team?.id);
        }}
      />

      <p>{label ?? team?.name ?? ""}</p>

      <div className="flex flex-row gap-4">
        {isConnected ? (
          <>
            {onEdit && (
              <Button
                variant="ghost"
                tooltip="Edit Connection"
                className="w-8 h-8 p-0"
                onClick={() => onEdit(tenantId, team?.id)}
              >
                <EditIcon className="w-5" />
              </Button>
            )}
            {onDisconnect && (
              <Button
                variant="ghost"
                tooltip="Delete Connection"
                className="w-8 h-8 p-0"
                onClick={() => setDeleteDialogOpen(true)}
              >
                <TrashIcon className="w-5" />
              </Button>
            )}
          </>
        ) : (
          onConnect && (
            <Button
              className="h-8 py-1"
              tooltip={
                team
                  ? "Create Connection for Team"
                  : "Create Default Connection"
              }
              onClick={() => onConnect?.(tenantId, team?.id)}
            >
              Connect
            </Button>
          )
        )}
      </div>
    </div>
  );
};
